var _rect, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DZone4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 386,
    width: 103.87,
    height: 23.51,
    rx: 11.755,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M665.75 403.255V402.232L672.023 392.869H665.682V391.619H673.704V392.641L667.432 402.005H673.773V403.255H665.75ZM685.888 397.437C685.888 398.664 685.666 399.725 685.223 400.619C684.78 401.513 684.172 402.202 683.399 402.687C682.626 403.172 681.744 403.414 680.751 403.414C679.759 403.414 678.876 403.172 678.103 402.687C677.331 402.202 676.723 401.513 676.28 400.619C675.836 399.725 675.615 398.664 675.615 397.437C675.615 396.21 675.836 395.149 676.28 394.255C676.723 393.361 677.331 392.672 678.103 392.187C678.876 391.702 679.759 391.46 680.751 391.46C681.744 391.46 682.626 391.702 683.399 392.187C684.172 392.672 684.78 393.361 685.223 394.255C685.666 395.149 685.888 396.21 685.888 397.437ZM684.524 397.437C684.524 396.429 684.355 395.579 684.018 394.886C683.685 394.193 683.232 393.668 682.66 393.312C682.092 392.956 681.456 392.778 680.751 392.778C680.047 392.778 679.408 392.956 678.836 393.312C678.268 393.668 677.816 394.193 677.478 394.886C677.145 395.579 676.978 396.429 676.978 397.437C676.978 398.444 677.145 399.295 677.478 399.988C677.816 400.681 678.268 401.206 678.836 401.562C679.408 401.918 680.047 402.096 680.751 402.096C681.456 402.096 682.092 401.918 682.66 401.562C683.232 401.206 683.685 400.681 684.018 399.988C684.355 399.295 684.524 398.444 684.524 397.437ZM697.964 391.619V403.255H696.601L690.26 394.119H690.146V403.255H688.737V391.619H690.101L696.464 400.778H696.578V391.619H697.964ZM701.264 403.255V391.619H708.287V392.869H702.673V396.8H707.923V398.05H702.673V402.005H708.377V403.255H701.264ZM715.809 400.869V399.71L720.923 391.619H721.764V393.414H721.195L717.332 399.528V399.619H724.218V400.869H715.809ZM721.286 403.255V400.516V399.977V391.619H722.627V403.255H721.286Z",
    fill: "#2E3838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 694.935,
    cy: 476.51,
    r: 25.3,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.935,
    cy: 476.51,
    r: 38,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.935,
    cy: 476.51,
    r: 13.65,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DZone4);
export default __webpack_public_path__ + "static/media/3d_zone_4.60e3156bfdac6327a9039cbdbd99e44f.svg";
export { ForwardRef as ReactComponent };